import "./$.js";
import "./imports.js";
import "./observers.js";
import "./dialog.js";

const genericTablLists = $$("nav.generic-tablist");

function setSelectedTab(tablist, selected) {
  const selectedTab = tablist.querySelector("button[aria-selected=true]");
  if (selectedTab) {
    selectedTab.setAttribute("aria-selected", false);
    // hide panel
    const selectedPanel = document.getElementById(selectedTab.getAttribute("aria-controls"));
    if (selectedPanel) {
      selectedPanel.classList.remove("open");
    }
  }
  selected.setAttribute("aria-selected", true);
  // show panel
  const panel = document.getElementById(selected.getAttribute("aria-controls"));
  if (panel) {
    panel.classList.add("open");
  }
}

genericTablLists.forEach((tablist) => {
  const buttons = tablist.querySelectorAll("button[role='tab']");
  buttons.forEach((button) => {
    const controls = button.getAttribute("aria-controls");
    // set url hash as the controls
    button.addEventListener("click", () => {
      setSelectedTab(tablist, button);
      window.location.hash = `#${controls}`;
    });
  });

  //check url hash and set the selected tab
  const hash = window.location.hash;
  if (hash) {
    const selected = tablist.querySelector(`button[aria-controls="${hash.substring(1)}"]`);
    if (selected) {
      setSelectedTab(tablist, selected);
    }
  }
});

$$(".inline-video-button").forEach((button) => {
  const video = button.parentElement.querySelector("video");
  if (video) {
    button.addEventListener("click", () => {
      if (video.paused) {
        video.play();
        video.classList.add("playing");
      } else {
        video.pause();
        video.classList.remove("playing");
      }
    });
  }
});

$$("video.inline-video").forEach((video) => {
  video.addEventListener("click", () => {
    if (video.paused) {
      video.play();
      video.classList.add("playing");
    } else {
      video.pause();
      video.classList.remove("playing");
    }
  });
});

//listen for ESC key to close search dialog
const searchField = $("header input[type='search']");
if (searchField) {
  const button = $("header input[type='search'] + button");
  searchField.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      // focus on button
      button.focus();
    }
  });
}

$$(".content table").forEach((table) => {
  const wrapper = document.createElement("div");
  wrapper.classList.add("table-wrapper");
  table.parentElement.insertBefore(wrapper, table);
  wrapper.appendChild(table);
});